module.exports = __webpack_public_path__ + "img/premium-img-3.b443335c.png";